export const visitedCountries = [
  "Austria","India","Albania","Andorra","Belgium","Bulgaria","Croatia","Czechia","Denmark","Estonia",
  "Finland","France","Germany","Greece","Hungary","Iceland","Ireland","Bosnia and Herzegovina",
  "Italy","Latvia","Lithuania","Luxembourg","Malta","Moldova","Monaco","Macedonia",
  "Montenegro","Netherlands","North Macedonia","Norway","Poland","Portugal",
  "Romania","San Marino","Republic of Serbia","Slovakia","Slovenia","Spain","Sweden",
  "Switzerland","United Kingdom","Vatican City", "Kosovo", "Uzbekistan","Thailand",
  "Malaysia","Indonesia","Singapore","Georgia","Azerbaijan", "Bhutan", "Turkey"
];

export const visitedCities = {
  "France": ["Paris", "Nice"],
  "Germany": ["Cologne"],
  "Italy": ["Rome", "Florence","Venice","Bologna","Trieste"],
  "Spain": ["Valencia","Barcelona"],
  "Portugal": ["Lisbon","Porto"],
  "Netherlands": ["Amsterdam","Eindhoven"],
  "Belgium": ["Gent","Antwerp","Brussels","Leuven"],
  "Switzerland": ["Bern"],
  "Austria": ["Vienna","Feldkirch"],
  "Ireland": ["Dublin"],
  "United Kingdom": ["London","Edinburgh"],
  "Norway": ["Oslo"],
  "Sweden": ["Gothenburg"],
  "Finland": ["Helsinki"],
  "Denmark": ["Copenhagen"],
  "Poland": ["Krakow","Wrocław"],
  "Czech Republic": ["Prague"],
  "Slovakia": ["Bratislava"],
  "Hungary": ["Budapest"],
  "Greece": ["Rhodos"],
  "Croatia": ["Zagreb"],
  "Slovenia": ["Llubljana"],
  "Bosnia and Herzegovina": ["Sarajevo","Mostar","Banja Luka"],
  "Serbia": ["Belgrade","Novi Sad"],
  "Montenegro": ["Kotor"],
  "Kosovo": ["Prizren"],
  "Albania": ["Tirana"],
  "North Macedonia": ["Skopje"],
  "Bulgaria": ["Sofia","Plovdiv"],
  "Romania": ["Bucharest","Brașov"],
  "Moldova": ["Chisinau"],
  "Estonia": ["Tallinn"],
  "Latvia": ["Riga"],
  "Lithuania": ["Vilnius","Kaunas"],
  "Luxembourg": ["Luxembourg city"],
  "Malta": ["Valletta","Mdina"],
  "Andorra": ["Andorra la Vella"],
  "San Marino": ["San Marino"],
  "Monaco": ["Monaco"],
  "Vatican City": ["Vatican city"],
  "Iceland": ["Reykjavík"],
  "Turkey": ["Istanbul"],
  "Uzbekistan": ["Tashkent","Samarkand"],
  "India": ["Agartala"],
  "Thailand": ["Bangkok"],
  "Malaysia": ["Kuala Lumpur"],
  "Indonesia": ["Jakarta"],
  "Singapore": ["Singapore city"]
};